import { createSlice } from '@reduxjs/toolkit';

export const apiValidationErrorSlice = createSlice({
    name: 'apiValidationError',
    initialState: { apiValidationErrors: [] },
    reducers: {
        storeApiValidationErrors(state, { payload }) {
            return {
                ...state,
                apiValidationErrors: payload,
            };
        },
        clearApiValidationErrors(state) {
            state.apiValidationErrors = [];
        },
    },
});

export const { storeApiValidationErrors, clearApiValidationErrors } = apiValidationErrorSlice.actions;
